<template>
    <a-layout class="admin-layout" has-sider>
        <!-- 侧边导航栏 -->
        <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible class="admin-sider" :width="200"
            :collapsed-width="80">
            <div class="logo">
                <h2 v-if="!collapsed">博客管理后台</h2>
                <h2 v-else>后台</h2>
            </div>
            <a-menu v-model:selectedKeys="selectedKeys" theme="dark" mode="inline" @click="handleMenuClick">
                <a-menu-item key="overview">
                    <DashboardOutlined />
                    <span>概览</span>
                </a-menu-item>
                <a-menu-item key="articles">
                    <FileTextOutlined />
                    <span>文章管理</span>
                </a-menu-item>
                <a-menu-item key="categories">
                    <FolderOutlined />
                    <span>分类管理</span>
                </a-menu-item>
                <a-menu-item key="tags">
                    <TagOutlined />
                    <span>标签管理</span>
                </a-menu-item>
                <a-menu-item key="users">
                    <TeamOutlined />
                    <span>用户管理</span>
                </a-menu-item>
                <a-menu-item key="system">
                    <ControlOutlined />
                    <span>系统管理</span>
                </a-menu-item>
                <a-menu-item key="settings">
                    <SettingOutlined />
                    <span>系统设置</span>
                </a-menu-item>
            </a-menu>

            <!-- 底部用户菜单 -->
            <div class="sider-footer">
                <a-dropdown placement="topLeft" :trigger="['click']">
                    <template #overlay>
                        <a-menu>
                            <a-menu-item key="profile">
                                <UserOutlined />
                                个人设置
                            </a-menu-item>
                            <a-menu-divider />
                            <a-menu-item key="logout" @click="logout">
                                <LogoutOutlined />
                                退出登录
                            </a-menu-item>
                        </a-menu>
                    </template>
                    <div class="user-info">
                        <UserOutlined class="user-avatar" />
                        <span v-if="!collapsed" class="user-name">{{ user?.email?.split('@')[0] || '管理员' }}</span>
                        <DownOutlined v-if="!collapsed" class="dropdown-icon" />
                    </div>
                </a-dropdown>

                <a-button type="text" @click="collapsed = !collapsed" class="collapse-btn">
                    <MenuUnfoldOutlined v-if="collapsed" />
                    <MenuFoldOutlined v-else />
                </a-button>
            </div>
        </a-layout-sider>

        <a-layout class="main-layout" :class="{ 'collapsed': collapsed }">
            <!-- 主要内容区 -->
            <a-layout-content class="admin-content">
                <div class="content-container">
                    <!-- 内容区域 -->
                    <div class="page-content">
                        <!-- 概览页面 -->
                        <div v-if="activeView === 'overview'" class="overview-page">
                            <a-row :gutter="[24, 24]">
                                <!-- 统计卡片 -->
                                <a-col :xs="24" :sm="12" :lg="6">
                                    <a-card class="stat-card">
                                        <a-statistic title="总文章数" :value="stats.totalArticles">
                                            <template #prefix>
                                                <FileTextOutlined />
                                            </template>
                                        </a-statistic>
                                    </a-card>
                                </a-col>
                                <a-col :xs="24" :sm="12" :lg="6">
                                    <a-card class="stat-card">
                                        <a-statistic title="公开文章" :value="stats.publicArticles">
                                            <template #prefix>
                                                <EyeOutlined />
                                            </template>
                                        </a-statistic>
                                    </a-card>
                                </a-col>
                                <a-col :xs="24" :sm="12" :lg="6">
                                    <a-card class="stat-card">
                                        <a-statistic title="草稿文章" :value="stats.draftArticles">
                                            <template #prefix>
                                                <EditOutlined />
                                            </template>
                                        </a-statistic>
                                    </a-card>
                                </a-col>
                                <a-col :xs="24" :sm="12" :lg="6">
                                    <a-card class="stat-card">
                                        <a-statistic title="已删除" :value="stats.deletedArticles">
                                            <template #prefix>
                                                <DeleteOutlined />
                                            </template>
                                        </a-statistic>
                                    </a-card>
                                </a-col>
                            </a-row>

                            <!-- 快速操作 -->
                            <a-card title="快速操作" class="quick-actions-card">
                                <a-row :gutter="[16, 16]">
                                    <a-col :xs="24" :sm="12" :md="8" :lg="6">
                                        <a-button type="primary" size="large" block @click="goToEditor">
                                            <PlusOutlined />
                                            写新文章
                                        </a-button>
                                    </a-col>
                                    <a-col :xs="24" :sm="12" :md="8" :lg="6">
                                        <a-button size="large" block @click="activeView = 'categories'">
                                            <FolderOutlined />
                                            管理分类
                                        </a-button>
                                    </a-col>
                                    <a-col :xs="24" :sm="12" :md="8" :lg="6">
                                        <a-button size="large" block @click="activeView = 'tags'">
                                            <TagOutlined />
                                            管理标签
                                        </a-button>
                                    </a-col>
                                    <a-col :xs="24" :sm="12" :md="8" :lg="6">
                                        <a-button size="large" block @click="activeView = 'settings'">
                                            <SettingOutlined />
                                            系统设置
                                        </a-button>
                                    </a-col>
                                </a-row>
                            </a-card>

                            <!-- 最近文章 -->
                            <a-card title="最近文章" class="recent-articles-card">
                                <a-list :data-source="recentArticles" :loading="loading">
                                    <template #renderItem="{ item }">
                                        <a-list-item>
                                            <template #actions>
                                                <a @click="editArticle(item.id)">编辑</a>
                                                <a @click="viewArticle(item.id)">查看</a>
                                            </template>
                                            <a-list-item-meta>
                                                <template #title>
                                                    <a @click="editArticle(item.id)">{{ item.title }}</a>
                                                </template>
                                                <template #description>
                                                    <a-space>
                                                        <a-tag
                                                            :color="item.visibility === 'public' ? 'green' : 'orange'">
                                                            {{ item.visibility === 'public' ? '公开' : '草稿' }}
                                                        </a-tag>
                                                        <span>{{ formatDate(item.updated_at) }}</span>
                                                    </a-space>
                                                </template>
                                            </a-list-item-meta>
                                        </a-list-item>
                                    </template>
                                </a-list>
                            </a-card>
                        </div>

                        <!-- 文章管理页面 -->
                        <ArticleManagement v-else-if="activeView === 'articles'" />

                        <!-- 分类管理页面 -->
                        <CategoryManagement v-else-if="activeView === 'categories'" />

                        <!-- 标签管理页面 -->
                        <TagManagement v-else-if="activeView === 'tags'" />

                        <!-- 用户管理页面 -->
                        <UserManagement v-else-if="activeView === 'users'" />

                        <!-- 系统管理页面 -->
                        <SystemManagement v-else-if="activeView === 'system'" />

                        <!-- 系统设置页面 -->
                        <div v-else-if="activeView === 'settings'" class="settings-page">
                            <a-card title="系统设置">
                                <p>系统设置功能正在开发中...</p>
                            </a-card>
                        </div>
                    </div>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script>
import { ref, reactive, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import {
    Layout, Menu, Card, Button, Dropdown, Statistic, Row, Col, List, Tag, Space
} from 'ant-design-vue'
import {
    UserOutlined, LogoutOutlined, DownOutlined, FileTextOutlined, FolderOutlined,
    TagOutlined, TeamOutlined, SettingOutlined, PlusOutlined, EyeOutlined,
    EditOutlined, DeleteOutlined, DashboardOutlined, MenuUnfoldOutlined, MenuFoldOutlined,
    ControlOutlined
} from '@ant-design/icons-vue'
import supabaseAuthService from '../../services/supabaseAuthService'
import supabaseArticleService from '../../services/supabaseArticleService'
import CategoryManagement from './CategoryManagement.vue'
import TagManagement from './TagManagement.vue'
import ArticleManagement from './ArticleManagement.vue'
import UserManagement from './UserManagement.vue'
import SystemManagement from './SystemManagement.vue'

export default {
    name: 'AdminDashboard',
    components: {
        'a-layout': Layout,
        'a-layout-header': Layout.Header,
        'a-layout-content': Layout.Content,
        'a-layout-sider': Layout.Sider,
        'a-menu': Menu,
        'a-menu-item': Menu.Item,
        'a-menu-divider': Menu.Divider,
        'a-card': Card,
        'a-button': Button,
        'a-dropdown': Dropdown,
        'a-statistic': Statistic,
        'a-row': Row,
        'a-col': Col,
        'a-list': List,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-tag': Tag,
        'a-space': Space,
        UserOutlined, LogoutOutlined, DownOutlined, FileTextOutlined, FolderOutlined,
        TagOutlined, TeamOutlined, SettingOutlined, PlusOutlined, EyeOutlined,
        EditOutlined, DeleteOutlined, DashboardOutlined, MenuUnfoldOutlined, MenuFoldOutlined,
        ControlOutlined,
        CategoryManagement,
        TagManagement,
        UserManagement,
        ArticleManagement,
        SystemManagement
    },
    setup() {
        const router = useRouter()
        const user = ref(null)
        const loading = ref(false)
        const activeView = ref('overview')
        const selectedKeys = ref(['overview'])
        const collapsed = ref(false)



        const stats = reactive({
            totalArticles: 0,
            publicArticles: 0,
            draftArticles: 0,
            deletedArticles: 0
        })

        const recentArticles = ref([])

        // 获取用户信息
        const getCurrentUser = async () => {
            try {
                user.value = await supabaseAuthService.getCurrentUser()
            } catch (error) {
                console.error('获取用户信息失败:', error)
                router.push('/admin/login')
            }
        }

        // 获取统计数据
        const loadStats = async () => {
            try {
                loading.value = true
                const articles = await supabaseArticleService.getArticles()

                stats.totalArticles = articles.length
                stats.publicArticles = articles.filter(a => a.visibility === 'public').length
                stats.draftArticles = articles.filter(a => a.visibility === 'draft').length
                stats.deletedArticles = articles.filter(a => a.visibility === 'deleted').length

                // 获取最近的5篇文章
                recentArticles.value = articles
                    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
                    .slice(0, 5)
            } catch (error) {
                console.error('加载统计数据失败:', error)
                message.error('加载数据失败')
            } finally {
                loading.value = false
            }
        }

        // 处理菜单点击
        const handleMenuClick = ({ key }) => {
            // 所有菜单项都在当前页面内切换视图
            activeView.value = key
            selectedKeys.value = [key]
        }

        // 退出登录
        const logout = async () => {
            try {
                await supabaseAuthService.signOut()
                message.success('已退出登录')
                router.push('/admin/login')
            } catch (error) {
                console.error('退出登录失败:', error)
                message.error('退出登录失败')
            }
        }

        // 跳转到编辑器
        const goToEditor = () => {
            router.push('/admin/editor')
        }

        // 编辑文章
        const editArticle = (id) => {
            router.push(`/admin/editor/${id}`)
        }

        // 查看文章
        const viewArticle = (id) => {
            router.push(`/article/${id}`)
        }

        // 格式化日期
        const formatDate = (dateString) => {
            return new Date(dateString).toLocaleDateString('zh-CN', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        }

        onMounted(() => {
            getCurrentUser()
            loadStats()
        })

        return {
            user,
            loading,
            activeView,
            selectedKeys,
            collapsed,
            stats,
            recentArticles,
            handleMenuClick,
            logout,
            goToEditor,
            editArticle,
            viewArticle,
            formatDate,
            DashboardOutlined,
            MenuUnfoldOutlined,
            MenuFoldOutlined
        }
    }
}
</script>

<style scoped>
.admin-layout {
    min-height: 100vh;
}

.admin-sider {
    overflow: auto;
    height: 100vh;
    position: fixed !important;
    left: 0;
    top: 0;
    bottom: 0;
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.admin-sider .ant-menu {
    padding-bottom: 120px;
}

.logo {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #001529;
}

.logo h2 {
    color: #1890ff;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
}

.sider-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    background: #001529;
    border-top: 1px solid #303030;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s;
    margin-bottom: 8px;
}

.user-info:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #1890ff;
}

.user-avatar {
    font-size: 16px;
}

.user-name {
    flex: 1;
    font-size: 14px;
}

.dropdown-icon {
    font-size: 12px;
}

.collapse-btn {
    width: 100%;
    height: 32px;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid #303030;
    background: transparent;
}

.collapse-btn:hover {
    color: #1890ff;
    border-color: #1890ff;
    background: rgba(24, 144, 255, 0.1);
}

.main-layout {
    margin-left: 200px;
    transition: margin-left 0.2s;
    width: calc(100vw - 200px);
    max-width: calc(100vw - 200px);
}

.main-layout.collapsed {
    margin-left: 80px;
    width: calc(100vw - 80px);
    max-width: calc(100vw - 80px);
}

.admin-content {
    margin: 0;
    overflow: initial;
    width: 100%;
    max-width: 100%;
}

.content-container {
    padding: 0;
    background: #fff;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.page-content {
    background: transparent;
    padding: 24px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

.overview-page {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    max-width: 100%;
}

.stat-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-card :deep(.ant-statistic-title) {
    color: #666;
    font-size: 14px;
}

.stat-card :deep(.ant-statistic-content) {
    font-size: 24px;
    font-weight: 600;
}

.quick-actions-card,
.recent-articles-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.quick-actions-card :deep(.ant-card-head-title),
.recent-articles-card :deep(.ant-card-head-title) {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
}

.recent-articles-card :deep(.ant-list-item-meta-title a) {
    color: #262626;
    font-weight: 500;
}

.recent-articles-card :deep(.ant-list-item-meta-title a:hover) {
    color: #1890ff;
}

.recent-articles-card :deep(.ant-list-item-action a) {
    color: #1890ff;
}

.recent-articles-card :deep(.ant-list-item-action a:hover) {
    color: #40a9ff;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .header-content {
        padding: 0 16px;
    }

    .header-left {
        gap: 12px;
    }

    .admin-title {
        font-size: 18px;
    }

    .admin-subtitle {
        display: none;
    }

    .content-container {
        padding: 16px;
    }

    .nav-menu {
        margin-bottom: 16px;
    }

    .overview-page {
        gap: 16px;
    }
}

/* 使用默认的侧边栏菜单样式 */

/* 确保布局正确 */
:deep(.ant-layout-has-sider) {
    display: block !important;
}
</style>